import Organization from ".";
import TabsNavigation from "../../../../components/elements/TabsNavigation";

const tabRoutes = [
  // {
  //   label: "List",
  //   icon: "fa-regular fa-building",
  //   path: "/admin/organization",
  // },
];

export const organizationRoutes = (data) => [
  {
    path: "/admin/company",
    component: () => (
      <TabsNavigation title="Company Management" tabRoutes={tabRoutes}>
        <Organization />
      </TabsNavigation>
    ),
    title: "Page",
    layout: "admin",
    routeType: "admin",
  },
];
